export default __webpack_public_path__ + "static/media/Icon awesome-file-upload.797f6147.svg";